module.exports = __webpack_public_path__ + "img/mac_default.961e4f44.png";